import { persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import { combineReducers } from '@reduxjs/toolkit';

import apiReducer from '@/store/api';
import articleReducer from '@/store/article';
import authReducer from '@/store/auth';
import openIdVerificationReducer from '@/store/openIdVerification';
import errorReducer from '@/store/error';
import affiliationReducer from '@/store/organization/affiliation';
import contactReducer from '@/store/organization/contact';
import billingContactReducer from '@/store/organization/billingContact';
import projectClassReducer from '@/store/organization/projectClass';
import serviceReducer from '@/store/organization/service';
import subscriptionReducer from '@/store/organization/subscription';
import flashMessageReducer from '@/store/flashMessage';
import noticeReducer from '@/store/notice';
import productAdminRoleReducer from '@/store/productAdminRole/slice';
import { isProduction, isStaging } from '@/settings/environment';

const transforms = [] as any[];
if (isProduction() || isStaging()) {
  const encryptor = encryptTransform({
    secretKey: process.env.REACT_APP_PERSIST_KEY || '',
  });
  transforms.push(encryptor);
}

const authPersistConfig = {
  transforms,
  storage,
  version: 1,
  key: 'auth',
  whitelist: ['session', 'current'],
};

const openIdVerificationPersistConfig = {
  transforms,
  storage: storageSession,
  version: 1,
  key: 'openIdVerification',
  whitelist: ['state', 'nonce', 'codeVerifier'],
};

const articlePersistConfig = {
  storage,
  version: 1,
  key: 'article',
  whitelist: ['readArticleIds'],
};

const rootReducer = combineReducers({
  article: persistReducer(articlePersistConfig, articleReducer),
  auth: persistReducer(authPersistConfig, authReducer),
  openIdVerification: persistReducer(
    openIdVerificationPersistConfig,
    openIdVerificationReducer,
  ),
  api: apiReducer,
  error: errorReducer,
  notice: noticeReducer,
  organization: combineReducers({
    affiliation: affiliationReducer,
    subscription: subscriptionReducer,
    contact: contactReducer,
    billingContact: billingContactReducer,
    service: serviceReducer,
    projectClass: projectClassReducer,
  }),
  flashMessage: flashMessageReducer,
  productAdminRole: productAdminRoleReducer,
});

export default rootReducer;
